/* tslint:disable */
/* eslint-disable */
/**
 * Product Page Aggregator
 * Aggregator for the product page on web and native apps
 *
 * The version of the OpenAPI document: 1
 * Contact: mark.salt@autotrader.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const TermKeyEnum = {
    Product: 'PRODUCT',
    CustomerDeposit: 'CUSTOMER_DEPOSIT',
    ManufacturerContribution: 'MANUFACTURER_CONTRIBUTION',
    DealerContribution: 'DEALER_CONTRIBUTION',
    TotalDeposit: 'TOTAL_DEPOSIT',
    MinimumDeposit: 'MINIMUM_DEPOSIT',
    ContractLength: 'CONTRACT_LENGTH',
    RepresentativeApr: 'REPRESENTATIVE_APR',
    AnnualMileage: 'ANNUAL_MILEAGE',
    Lender: 'LENDER'
};
/**
 * Check if a given object implements the Term interface.
 */
export function instanceOfTerm(value) {
    if (!('key' in value) || value['key'] === undefined)
        return false;
    if (!('text' in value) || value['text'] === undefined)
        return false;
    return true;
}
export function TermFromJSON(json) {
    return TermFromJSONTyped(json, false);
}
export function TermFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'key': json['key'],
        'text': json['text'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}
export function TermToJSON(json) {
    return TermToJSONTyped(json, false);
}
export function TermToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'key': value['key'],
        'text': value['text'],
        'value': value['value'],
    };
}
